export default __webpack_public_path__ + "static/media/mw-logo.bc832df6.png";